import React from 'react';
import PropTypes from 'prop-types';
import Layout from 'layout';
import { Route, Router, Switch } from 'react-router-dom';
import QrForm from 'components/QrForm';
import NotFoundPage from 'components/NotFoundPage';
import history from './history';

const AppPath = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(params) => {
      const props = { ...params };
      const layoutProps = {
        path: props.match.path,
      };

      return (
        <Layout {...layoutProps}>
          <Component />
        </Layout>
      );
    }}
  />
);

const Routes = () => (
  <Router history={history}>
    <Switch>
      <AppPath
        exact
        path="/payment-incident"
        component={QrForm}
        layout={Layout}
      />
      <AppPath path="*" exact component={NotFoundPage} layout={Layout} />
    </Switch>
  </Router>
);

AppPath.propTypes = {
  component: PropTypes.func.isRequired,
  redirectToPage: PropTypes.func,
  match: PropTypes.object,
};

AppPath.defaultProps = {
  match: {},
  redirectToPage: () => {},
};

export default Routes;
